// === SAA:UTILS:PRODUCT-PREMIUM ===
// "Does this product have a calculated premium?" read from the STORED engine output.
// Shared by the selection card (done state) and the progress-step navigation
// (first product that still needs a premium; premium value as the change fingerprint).
// DELIBERATELY stricter than WorkflowSummaryScreen's any-product check for personenauto
// and rechtsbijstand (which only test that Contractdocument.PP exists): this reads the
// actual PP_TTOT. Do not "fix" either side to match the other without knowing this.

const PREMIUM_READS: Record<string, (pp: any) => unknown> = {
  aansprakelijkheid: (pp) => pp?.DA?.DA_TTOT || pp?.PP_TTOT,
  woonhuis: (pp) => pp?.PP_TTOT,
  inboedel: (pp) => pp?.PP_TTOT,
  personenauto: (pp) => pp?.PP_TTOT,
  rechtsbijstand: (pp) => pp?.PP_TTOT,
  ongevallen: (pp) => pp?.PP_TTOT || pp?.OD?.OD_NTP,
  doorlopendereis: (pp) => pp?.PP_TTOT,
};

/** The stored premium as a string, or null when the product has none (unknown product = null). */
export const readCalculatedPremium = (productId: string, stepData: any): string | null => {
  const value = PREMIUM_READS[productId]?.(stepData?.Contractdocument?.PP);
  return value ? String(value) : null;
};

export const hasCalculatedPremium = (productId: string, stepData: any): boolean =>
  readCalculatedPremium(productId, stepData) !== null;
